




import { Vue, Component, Prop } from 'vue-property-decorator'
import intToBase64 from 'src/assets/intToBase64'

@Component
export default class ItemTopicViewerParams extends Vue {

  @Prop()
  readonly slide!: Json

  get name () {
    const name = intToBase64(this.slide.id).replace(/[\+\/]/, '&').substr(0, 6).toUpperCase()
    return name.substr(0, 3) + '-' + name.substr(3, 3)
  }
}
